import { Typography } from '@stern-ui/ui';
import { CellContext } from '@tanstack/react-table';

import { DataTableObject } from '@/components/PatientDataTable';
import { PatientObject } from '@/types';
import { formatDate, formatSnakeCase, formatSentenceCase } from '@/utils';

import { FetchPatientScreeningObject } from '../types';

type CellContextExtended = CellContext<DataTableObject, string> & FetchPatientScreeningObject;

export const LastContactedCell = ({ props }: { props: CellContextExtended }) => {
	const { last_contact_at, last_contact_method } = props.row.original as PatientObject;

	const formatLastContactMethod = (str: string | null | undefined) => {
		if (!str) return null;
		return formatSnakeCase(formatSentenceCase(str));
	};

	return (
		<>
			<div>{formatDate(last_contact_at)}</div>
			<div>
				<Typography variant='bodySmall' className='text-secondaryTextDark'>
					{formatLastContactMethod(last_contact_method)}
				</Typography>
			</div>
		</>
	);
};
